import DefaultText from "../../../../../components/typography/default-text";
import { getDiretoresPorLinha } from "./diretoresList";
import styles from "./styles.module.css";

const Diretores: React.FC = () => {
  const linhas = getDiretoresPorLinha();

  return (
    <div className={styles["sub-page-content"]}>
      <div>
        <DefaultText size="medium" sx={{ fontFamily: 'Montserrat-Regular' }}>Nossos</DefaultText>
        <DefaultText size="medium" sx={{ fontFamily: 'Montserrat-Bold' }}><i>Diretores</i></DefaultText>
      </div>
      <div className={styles["directors-grid"]}>
        {linhas.map((row, rowIndex) => (
          <div key={rowIndex} className={styles["directors-row"]}>
            {row.map((diretor, index) => (
              <div className={styles["director-card"]} key={`${rowIndex}-${index}`}>
                <div className={styles["director-image-wrap"]}>
                  <img
                    src={diretor.image}
                    alt={`Foto do diretor ${diretor.name}`}
                    className={styles["director-image"]}
                  />
                </div>
                <div className={styles["director-info-wrap"]}>
                <div className={styles["director-info-name"]}>
                  <DefaultText size="small" sx={{ fontFamily: 'Montserrat-Bold' }}>{diretor.name}</DefaultText>
                </div>
                <div className={styles["director-info-role"]}>
                  <DefaultText size="xs">{diretor.role}</DefaultText>
                </div>
              </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Diretores;